import { render } from "./MaterialGallery.vue?vue&type=template&id=2c1d9c4b&scoped=true"
import script from "./MaterialGallery.vue?vue&type=script&lang=js"
export * from "./MaterialGallery.vue?vue&type=script&lang=js"

import "./MaterialGallery.vue?vue&type=style&index=0&id=2c1d9c4b&scoped=true&lang=scss"
import "./MaterialGallery.vue?vue&type=style&index=1&id=2c1d9c4b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1d9c4b"]])

export default __exports__